import "./NewEngineering.css";
import "./serviceEditor.css";
import { NavLink } from "react-router-dom";
import Avatar1 from '../../Images/commission_1.png';
import { ServiceEditModal, usePageEditor, resolveUrl } from "./serviceEditorShared";

const servicesNav = [
  { label: "Engineering",                    href: "/engineering" },
  { label: "Procurement",                    href: "/procurement" },
  { label: "Construction",                   href: "/construction" },
  { label: "Installation & Instrumentation", href: "/installation-instrumentation" },
  { label: "Commissioning",                  href: "/commissioning" },
  { label: "Manpower-supply",                href: "/manpower-supply" },
  { label: "Marine Support",                 href: "/marine-support" },
];

const DEFAULT_DATA = {
  bannerImage: "",
  title: "Our commissioning services covers, systematic inspection, testing and validation of mechanical, electrical, instrumentation control, and process systems across upstream, midstream, and downstream facilities.",
  paragraphs: [
    "We adopt industry best practices and internationally recognized standards to ensure safe handover, operational readiness, and compliance with HSE, Clients' specification and statutory requirements. Through detailed planning, experienced personnel, and disciplined execution, we help clients minimize risks, reduce downtime, and achieve reliable success.",
    "Our commissioning expertise supports onshore and offshore facilities, including production plants, pipelines, terminals, refineries, and gas processing units, delivering seamless transition from construction to stable operations.",
  ],
  sections: [],
};

export default function Commissioning() {
  const { pageData, loading, fetchErr, fetchData, modalOpen, setModalOpen, saving, handleSave, saveMsg } =
    usePageEditor("/api/commissioning", DEFAULT_DATA);

  const bannerImg = resolveUrl(pageData.bannerImage) || Avatar1;

  return (
    <>
      <button className="edit-fab" onClick={() => setModalOpen(true)} title="Edit page content">
        <span className="edit-fab__icon">✏️</span>
        <span className="edit-fab__label">Edit Page</span>
      </button>

      {saveMsg  && <div className="editor-toast">{saveMsg}</div>}
      {loading  && <div className="editor-loading"><div className="editor-loading__spinner" /></div>}
      {fetchErr && <div className="editor-error-banner">{fetchErr}<button onClick={fetchData}>Retry</button></div>}
      {modalOpen && (
        <ServiceEditModal data={pageData} onSave={handleSave} onClose={() => setModalOpen(false)} saving={saving} pageLabel="Commissioning" />
      )}

      <div className="img_carrier">
        <img src={bannerImg} alt="" />
      </div>

      <section className="service-detail">
        <div className="service-detail__layout">
          <div className="service-detail__content">
            <h2 className="service-detail__title">{pageData.title}</h2>
            <span className="service-detail__divider" />
            {pageData.paragraphs.map((p, i) => <p key={i} className="service-detail__intro">{p}</p>)}
            {pageData.sections.map((sec, i) => (
              <div key={i} className="service-detail__section">
                <h3 className="service-detail__section-heading">{sec.heading}</h3>
                <ul className="service-detail__list">
                  {sec.items.map((item, j) => <li key={j} className="service-detail__list-item">{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <nav className="service-detail__tabs" aria-label="Service navigation">
            {servicesNav.map((s) => (
              <NavLink key={s.href} to={s.href} className={({ isActive }) => `service-detail__tab${isActive ? " service-detail__tab--active" : ""}`}>
                {s.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </section>
    </>
  );
}
